import { FC, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from '@material-ui/core';
import styled from 'styled-components';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { translate } from 'containers/services/translate';
import * as featureService from 'features/fflip-helpers';
import {
  CIVIL_PROCEEDING_INFORMATIONS_FIELDS,
  EMPTY_CIVIL_PROCEEDING_INFO_FIELDS,
  PROCEDURE_STATUSES,
} from 'containers/data-structure';
import { get, isEmpty } from 'lodash';
import { FEATURES } from 'features/features';
import InfoIcon from 'images/info-icon.svg';
import { Autocomplete } from '@material-ui/lab';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { filterStackHolder } from 'services/utils';

export interface AssignedLawyerProps {
  intl: IntlShape;
  info: any;
  listings: any;
  setCivilProceedingInfo: Function;
  stakeholders: any;
  setIsUpdated: Function;
  readOnly: boolean;
  judgementAdd?: any;
  judgementOnMerits?: any;
}
export const AssignedLawyer: FC<AssignedLawyerProps> = props => {
  const AssignmentWarning = styled.div`
    padding: 16px 16px 24px 16px;
    border-radius: 8px;
    background: var(--primary-100, #e6f1fa);
    margin-top: 10px;
    margin-bottom: 10px;
  `;
  const { assignedLawyer, assignment, assignedLawyers } = props.info;
  const [updatedCivilProceedingInfo, setUpdatedCivilProceedingInfo] = useState({
    ...EMPTY_CIVIL_PROCEEDING_INFO_FIELDS,
  });
  /* istanbul ignore next */
  const [assignedLawyersList, setAssignedLawyersList] = useState<any>(
    assignedLawyers
      ? assignedLawyers.map((el: any) =>
          props.stakeholders.find((item: any) => item.ItemKey === el),
        )
      : [],
  );
  /* istanbul ignore next */
  useDeepCompareEffect(() => {
    setAssignedLawyersList(
      assignedLawyers
        ? assignedLawyers.map((el: any) =>
            props.stakeholders.find((item: any) => item.ItemKey === el),
          )
        : [],
    );
  }, [assignedLawyers, props.stakeholders]);
  /* istanbul ignore next */
  const handleChangeMultipleAssignment = (field: string) => (
    event: React.ChangeEvent<{}>,
    value: any,
  ) => {
    setAssignedLawyersList(
      typeof value === 'string' ? value.split(',') : value,
    );
    setUpdatedCivilProceedingInfo({
      ...updatedCivilProceedingInfo,
      [field]: value.map((el: any) => el?.ItemKey),
    } as any);
    props.setCivilProceedingInfo({
      ...props.info,
      [field]: value.map((el: any) => el?.ItemKey),
    });
    props.setIsUpdated(true);
  };

  /* istanbul ignore next */
  const handleChange = (field: string) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    setUpdatedCivilProceedingInfo({
      ...updatedCivilProceedingInfo,
      [field]: event.target.value,
    });
    props.setCivilProceedingInfo({
      ...props.info,
      [field]: event.target.value,
    });
    props.setIsUpdated(true);
  };
  return (
    <Grid container>
      {(!isEmpty(props.judgementAdd) || !isEmpty(props.judgementOnMerits)) &&
        get(props.info, 'status') === PROCEDURE_STATUSES.PENDING &&
        !assignedLawyersList.includes(get(props.info, 'assignedLawyer')) && (
          <AssignmentWarning>
            <img src={InfoIcon} alt="InfoIcon" />
            <span style={{ margin: '5px' }}>
              {translate({ ...messages.assignmentLawyerWarning }, props)}
            </span>
          </AssignmentWarning>
        )}
      <Grid container item spacing={3} style={{ marginTop: 10 }}>
        {featureService.hasFeature(FEATURES.ASSIGNMENT_MULTIPLE_LAWYERS) &&
        !isEmpty(assignment) ? (
          <>
            <Grid item xs={6}>
              <FormControl className="select">
                <Autocomplete
                  className="lawyer-item"
                  multiple
                  id="assignedLawyers"
                  options={filterStackHolder(props.stakeholders)}
                  getOptionLabel={
                    /* istanbul ignore next */ (option: any) =>
                      `${option?.ItemDescription}`
                  }
                  value={assignedLawyersList}
                  onChange={handleChangeMultipleAssignment(
                    CIVIL_PROCEEDING_INFORMATIONS_FIELDS.ASSIGNED_LAWYERS,
                  )}
                  disabled={props.readOnly}
                  renderInput={
                    /* istanbul ignore next */ params => (
                      <TextField {...params} variant="standard" />
                    )
                  }
                />
              </FormControl>
            </Grid>
          </>
        ) : (
          <Grid item xs={12}>
            <FormControl className="input" fullWidth>
              <InputLabel id="idd-label-id">
                {translate(messages.assignedLawyerTitle, props)}
              </InputLabel>
              <Select
                fullWidth
                onChange={handleChange(
                  CIVIL_PROCEEDING_INFORMATIONS_FIELDS.ASSIGNED_LAWYER,
                )}
                labelId="idd-label-id"
                value={parseInt(assignedLawyer)}
                readOnly={props.readOnly}
              >
                {filterStackHolder(props.stakeholders).map(
                  (element: { ItemKey: number; ItemDescription: string }) => (
                    <MenuItem value={element.ItemKey}>
                      {element.ItemDescription}
                    </MenuItem>
                  ),
                )}
              </Select>
            </FormControl>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default injectIntl(AssignedLawyer);
